import React from "react";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { RangeControl, CheckboxControl } from "../../Components";

import className from "../../style.module.scss";

export function ControlContainer(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const renderControl = () => {
    switch (props.control.type) {
      case "range":
        return (
          <RangeControl
            index={props.index}
            configData={props.control}
            updateVariable={props.updateVariable}
            dev={props.dev}
          />
        );
      case "checkbox":
        return (
          <CheckboxControl
            index={props.index}
            configData={props.control}
            updateVariable={props.updateVariable}
          />
        );
      default:
        console.log(
          "Control type not accounted for. (Supported types: range / checkbox)"
        );
    }
  };

  return (
    <label
      id={`control_${props.control.id}`}
      htmlFor={`${props.control.type}_${props.index}`}
      className={`
                ${props.control.type === "range" ? className.RangeControlContainer : ""}
                ${props.control.type === "checkbox" ? className.CheckboxControlContainer : ""}
            `}
    >
      {parse(t(`${props.control.label}.string`))}
      {renderControl()}
    </label>
  );
}

ControlContainer.propTypes = {
  control: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  updateVariable: PropTypes.func.isRequired,
};
ControlContainer.defaultProps = {};
